import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect,
  MultiSelect
} from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Services from './../../../../shared/components/Template1/newservices'
import ClientService from './../../../services/clientmanagement.service';
import CONSTANT from './../../../../shared/constants/constant';



export default {
  name: 'createContract',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    MultiSelect,
    MasterService,
    Services
  },
  props: ['CompanyShortList', 'selectedEditRowData'],
  data: function() {
    return {
      isLoading: false,
      companyNamelist: [],
      selectedcompanyName: {
        text: '',
        value: '',
        CompanyName: ''
      },
      companyName: '',
      contractIdList: [],
      contractId: '',
      callingToContractObj: {
        id: null,
        name: CONSTANT.CLIENT_CONTRACT_TEMPLATE,
        existingContractTemplateId: null,
        newlySelectedTemplateId: null,
        hideSaveNextButton:true,
      },
      selectedContractId: {
        text: '',
        value: ''
      },
      companyId: '',
      showContractTemplate: false,
      checkEdit: false,
      clientid: '',
      contractidtext: '',
      contractname: '',
      selectedEditRow: [],
    }
  },
  computed: {

  },
  mounted() {
    // this.getContractListing();
    if (this.CompanyShortList.length > 0) {} else {
      this.getCompanyShortName();
    }
    if (this.selectedEditRowData) {
      this.preFillServiceData()
    }
  },
  methods: {

    async preFillServiceData() {
      let obj = {
        text: this.selectedEditRowData.clientshortname,
        value: this.selectedEditRowData.clientid,
        CompanyName: this.selectedEditRowData.clientcompanyname
      }
      await this.selectCompanyName(obj)
      let contractLabel = this.contractIdList.filter(obj => obj.text == this.selectedEditRowData.contractidlabel)
      this.selectContractId(contractLabel[0])
    },

    async getCompanyShortName() {
      try {
        this.isLoading = true;
        var CompanyShortList = []
        let result = await ClientService.getCompanyShortName()
        CompanyShortList = result.data.data;
        console.log(result.data.data);
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.CompanyShortList.push({
            'value': CompanyShortList[i].ClientMasterID,
            'text': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
      }
    },
    async getContractList(obj) {
      try {
        this.contractIdList = [];
        if (!obj) {
          this.contractId = "";
          this.selectedContractId = {};
        }
        this.isLoading = true;
        let inputPayload = {
          clientid: this.companyId
        };
        let result = await ClientService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          this.contractIdList.push({
            'value': contractlist[i].id,
            'text': contractlist[i].contractidlabel
          });
          if (obj) {
            if (contractlist[i].id == this.contractId) {
              this.selectedContractId = {
                'value': contractlist[i].id,
                'text': contractlist[i].contractid
              }
            }
          }
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },

    selectContractId(data) {
      this.selectedContractId = data;
      this.contractId = data.value
      this.getAndSetSetectedTemplateData(data)
    },
    async getAndSetSetectedTemplateData(data) {
      try {
        let payload = {
          offset: 0,
          limit: 1,
          clientContractTemplateId: data.value,
          contractidlabel: data.text
        }
        this.isLoading = true
        this.showContractTemplate = false;
        this.$nextTick(async () => {
          let result = await ClientService.getClentContractDetial(payload)
          this.isLoading = false;
          this.clientid = result.data.data.rows[0].id
          this.contractidtext = result.data.data.rows[0].contractidlabel
          this.contractname = result.data.data.rows[0].contractname
          if (result.data.data.rows[0].contracttemplateid) {
            this.selectedEditRow = result.data.data.rows[0]
            this.callingToContractObj.id = data.value
            this.callingToContractObj.existingContractTemplateId = result.data.data.rows[0].contracttemplateid
          } else {
            // console.log("kgjgjg");
            // this.selectedEditRow = []
          }
          this.showContractTemplate = true;
        })
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    async selectCompanyName(data) {
      this.selectedcompanyName = data;
      this.companyId = data.value
      this.companyName = data.CompanyName;
      this.companyShortName = data.text;
      await this.getContractList();
    },
    showService() {
      this.$emit("goBackToParent")
    },
    saveAndNext() {
      this.showContract = true;
    },
    async UpdateClientService(payload, buttonclick) {
      try {
        // payload.clientid = this.companyId
        // payload.clientshortname = this.companyShortName
        // payload.clientcompanyname = this.companyName
        // payload.clientcontractid = this.contractidtext
        payload.contractid = this.callingToContractObj.id;
        payload.contracttemplateid = this.callingToContractObj.existingContractTemplateId;
        // payload.contractname = this.contractname
        this.isLoading = true
        let result = await ClientService.saveClientContractServices(payload);
        this.isLoading = false
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.companyShortName, "success");
          //this.callingToContractObj.existingContractTemplateId = result.data.data.contracttemplateid;
          // this.$refs.ContractChilds.getContractID(result.data.data.contracttemplateid, buttonclick);
          this.$emit("goBackToParent");
        } else {
          this.$alert(result.data.message, this.companyShortName, "error");
        }
      } catch (err) {
        this.isLoading = false;
        this.$alert(err, "Contract", "error");
        console.log(err);
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientServices/CreateClientServices/CreateClientServices.component.js